import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "@/components/Header";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

function canTeach(user) {
  return user?.role === "teacher" || user?.role === "admin";
}

export default function TeacherClassNew() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [term, setTerm] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!name.trim()) {
      toast.error("Class name is required.");
      return;
    }
    setSaving(true);
    try {
      const { data } = await api.post("/teacher/classes", { name, term });
      toast.success("Class created.");
      navigate(`/teacher/classes/${data.class_id}`);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not create class.");
    } finally {
      setSaving(false);
    }
  };

  if (!canTeach(user)) {
    return (
      <div className="min-h-screen bg-forge-900 text-forge-100">
        <Header />
        <main className="max-w-3xl mx-auto px-6 lg:px-10 py-20">
          <h1 className="font-serif text-4xl tracking-tight mb-4">Teacher access required.</h1>
          <Link to="/dashboard" className="text-ember-400 hover:text-ember-300">Return to dashboard</Link>
        </main>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-forge-900 text-forge-100">
      <Header />
      <main className="max-w-3xl mx-auto px-6 lg:px-10 py-12 sm:py-16">
        <Link to="/teacher" className="text-xs uppercase tracking-[0.25em] text-forge-100/45 hover:text-ember-400">Back to Teacher</Link>
        <div className="text-[10px] tracking-[0.4em] uppercase text-ember-500 mt-10 mb-3">Create Class</div>
        <h1 className="font-serif text-4xl sm:text-5xl tracking-tight mb-8">Start a pilot class.</h1>

        <form onSubmit={submit} className="space-y-8">
          <label className="block">
            <span className="block text-[10px] uppercase tracking-[0.3em] text-forge-100/50 mb-3">Class Name</span>
            <input
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full bg-transparent border-b border-white/15 focus:border-ember-500 outline-none py-3 text-forge-100 placeholder-forge-100/30 text-xl"
              placeholder="Intro to Critical Thinking"
            />
          </label>
          <label className="block">
            <span className="block text-[10px] uppercase tracking-[0.3em] text-forge-100/50 mb-3">Term</span>
            <input
              value={term}
              onChange={(e) => setTerm(e.target.value)}
              className="w-full bg-transparent border-b border-white/15 focus:border-ember-500 outline-none py-3 text-forge-100 placeholder-forge-100/30 text-xl"
              placeholder="Fall 2026"
            />
          </label>
          <button disabled={saving} className="px-6 py-2.5 bg-ember-500 hover:bg-ember-400 disabled:opacity-60 text-forge-900 font-semibold rounded-sm tracking-wide transition-all">
            {saving ? "Creating..." : "Create Class"}
          </button>
        </form>
      </main>
    </div>
  );
}
